module.exports = __webpack_public_path__ + "img/pflegeplan.7e5e4662.svg";